import { useParams } from 'react-router-dom'
import GateScreen from './GateScreen'

export default function GateScreenRoute() {
  const { gateId } = useParams()
  if (!gateId) return null
  return <GateScreen gateId={gateId} />
}
